// list of different origins for website
const probableOrigins = ['http://localhost:3000','http://localhost:3001','http://localhost:3002'];

//current origin
const currentOrigin = window.location.origin

//switch to dev server if on dev server
export const server = probableOrigins.includes(currentOrigin) ? 
process.env.REACT_APP_SERVER_DEV :
process.env.REACT_APP_SERVER;
